const AutomationList = async () =>
    import('../../pages/automations/List').then((module) => ({
        Component: module.AutomationList,
    }));
const OrderRouting = async () =>
    import('../../pages/automations/OrderRouting/OrderRouting').then((module) => ({
        Component: module.OrderRouting,
    }));
const OrderSyncConditions = async () =>
    import('../../pages/automations/OrderSyncConditions/OrderSyncConditions').then((module) => ({
        Component: module.OrderSyncConditions,
    }));

const getAutomationRoutes = (user) => {
    if (user?.carrierId) return [];

    return [
        {
            path: '/automations/',
            lazy: AutomationList,
        },
        {
            path: '/automations/order-routing',
            lazy: OrderRouting,
        },
        {
            path: '/automations/order-sync-conditions',
            lazy: OrderSyncConditions,
            condition: user.features?.automations?.orderIntegrationConditionsEnabled,
        },
    ];
};

export { getAutomationRoutes };
